<template>
    <div>
        <div v-if="outletLock" class="cart__outlet-notice">
          Вы исчерпали лимит заказов, свяжитесь с оператором в онлайн-чате
        </div>
        <div v-if="orders.length > 0" class="cart-done">
            <div class="cart-done__pic">
                <svg class="icon icon--plant cart-done__icon">
                    <use xlink:href="#icon-plant"></use>
                </svg>
                <span class="cart-done__thanks">Спасибо</span>
            </div>
            <div class="cart-done__main">
                <p class="cart-done__title">Спасибо за покупку!</p>
            </div>
        </div>


        <div v-for="(order, index) in orders">
            <basket-items-list :key="index" read-only finish show-title :show-coupons="index === orders.length - 1"
                               :order-number="order.id" :outlet="order.outlet">

            </basket-items-list>

            <div class="cart-info">
                <div class="cart-info__col">
                    <p class="cart-info__title">Информация о доставке</p>
                    <ul class="cart-info__list">
                        <li class="cart-info__item">
                            <span class="cart-info__key">Имя</span>
                            <span class="cart-info__value">{{form.firstName}}</span>
                        </li>
                        <li class="cart-info__item">
                            <span class="cart-info__key">Фамилия</span>
                            <span class="cart-info__value">{{form.lastName}}</span>
                        </li>
                        <li class="cart-info__item">
                            <span class="cart-info__key">Адрес</span>
                            <span class="cart-info__value">{{form.city}} {{form.street}} {{form.house}} {{form.flat}}</span>
                        </li>
                        <li class="cart-info__item">
                            <span class="cart-info__key">Телефон</span>
                            <span class="cart-info__value">{{form.phone}}</span>
                        </li>
                        <li class="cart-info__item">
                            <span class="cart-info__key">E-mail</span>
                            <span class="cart-info__value">{{form.email}}</span>
                        </li>
                    </ul>
                </div>
                <div class="cart-info__col">
                    <p class="cart-info__title">Способ доставки и оплаты</p>
                    <ul class="cart-info__list">
                        <li class="cart-info__item">
                            <span class="cart-info__key">Оплата</span>
                            <span class="cart-info__value">{{getPaymentType}}</span>
                        </li>
                        <li class="cart-info__item">
                            <span class="cart-info__key">Доставка</span>
                            <span class="cart-info__value">{{getDeliveryType}}</span>
                        </li>
                    </ul>
                </div>
                <div class="cart-info__col">
                    <p class="cart-info__title">Информация о заказе</p>
                    <ul class="cart-info__list">
                        <li class="cart-info__item">
                            <span class="cart-info__key">Стоимость</span>
                            <span class="cart-info__value cart-info__value--right" v-html="order.base_price"></span>
                        </li>
                        <li class="cart-info__item" v-if="order.discount">
                            <span class="cart-info__key">Скидка</span>
                            <span class="cart-info__value cart-info__value--right">
                            <svg class="icon icon--circle_minus cart-info__icon">
                                <use xlink:href="#icon-circle_minus"></use>
                            </svg>
                            <span v-html="order.discount.toFixed(2)"></span>
                        </span>
                        </li>

                        <li class="cart-info__item" v-if="order.delivery_price">
                            <span class="cart-info__key">Доставка</span>
                            <span class="cart-info__value cart-info__value--right">
                            <svg class="icon icon--circle_plus cart-info__icon">
                                <use xlink:href="#icon-circle_plus"></use>
                            </svg>
                            {{order.delivery_price}}
                        </span>
                        </li>
                        <li class="cart-info__item">
                            <span class="cart-info__key">Сумма заказа</span>
                            <span class="cart-info__value cart-info__value--right cart-info__value--total" :inner-html.prop="order.price | price"></span>
                        </li>
                    </ul>
                </div>

                <div class="cart__btn-container">
                    <a class="btn btn--blue cart__btn" href="/" v-if="index === orders.length - 1">На главную страницу</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import basketItemsList from "./basketItemsList.vue";
    import {mapState, mapGetters} from 'vuex';

    export default {
        name: "basket-finish",
        components: {basketItemsList},
        computed: {
            ...mapState(['outletLock','orders', 'form', 'total']),
            ...mapGetters(['getPaymentType','getDeliveryType','getDeliveryPrice','getTotalPrice'])
        },
        mounted() {
            this.orders.forEach(order => {
                const purchaseData = {
                    "transaction_id": order.id,
                    "value": order.price,
                    "currency": "RUB",
                    "tax": order.tax,
                    "shipping": order.delivery_price,
                    "items": order.items.map((item) => {
                        return {
                            "id": item.id,
                            "name": item.name,
                            "brand": item.brand,
                            "category": item.category,
                            "variant": item.variant,
                            "quantity": item.quantity,
                            "price": item.price,
                        };
                    }),
                };

                /** Yandex.Metrika e-commerce data */
                dataLayer.push({
                    "ecommerce": {
                        "purchase": {
                            "actionField": {
                                "id": order.id,
                            },
                            "products": purchaseData['items'],
                        }
                    }
                });
            })
        },
    }
</script>
